var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmarkXs = function SvgCheckmarkXs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.738 3.037c.424.355.491.995.151 1.43l-7.272 9.295a.96.96 0 0 1-1.353.17l-4.692-3.63a1.04 1.04 0 0 1-.204-1.422.96.96 0 0 1 1.376-.2l3.931 3.04 6.68-8.537a.96.96 0 0 1 1.383-.146Z",
    clipRule: "evenodd"
  })));
};
export { SvgCheckmarkXs as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij4KIDxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTQuNzM4IDMuMDM3Yy40MjQuMzU1LjQ5MS45OTUuMTUxIDEuNDNsLTcuMjcyIDkuMjk1YS45Ni45NiAwIDAgMS0xLjM1My4xN2wtNC42OTItMy42M2ExLjA0IDEuMDQgMCAwIDEtLjIwNC0xLjQyMi45Ni45NiAwIDAgMSAxLjM3Ni0uMmwzLjkzMSAzLjA0IDYuNjgtOC41MzdhLjk2Ljk2IDAgMCAxIDEuMzgzLS4xNDZaIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+Cg==";